// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"418b7c2e","494":"a989c6de","510":"9297336f"}[chunkId] + ".chunk.js";
};